<template>
  <component 
    :is="$store.getters.isMobile ? 'el-drawer' : 'el-dialog'" 
    :visible.sync="visible"
    v-bind="options" 
    class="reward-info-dialog"
  >
    <div slot="title" class="dialog-header-row">
      <div v-if="type === 'success'" class="success-header">
        <div class="icon-wrap">
          <i class="el-icon-check" />
        </div>
        <span class="success-title">{{ title }}</span>
      </div>
      <span v-else class="title-text">{{ title || $t('siteBuild.reward') }}</span>
      <i class="el-icon-close close-btn" @click="handleClose" />
    </div>
    <div class="reward-info-content" :style="customStyle">
      <div class="gift-list">
        <div v-for="(item, index) in data.gift_list" :key="index" class="gift-item">
          <div class="gift-info">
            <div
              class="gift-img-wrap"
              :class="{ 'has-level': !!item.level_icon }"
              :style="item.level_icon ? { '--level-bg': `url('${item.level_icon}')` } : null">
              <img class="gift-img" :src="item.gift_goods_logo" alt="" />
            </div>
            <span class="gift-name">{{ getLangIdI18n({ lang_id: item.gift_goods_name }, $store.state.locale.langIdData) }}</span>
          </div>
          
          <div class="gift-count">
            <i class="el-icon-close count-icon" />
            <span class="count-text">{{ item.num }}</span>
          </div>
        </div>
      </div>
    </div>
  </component>
</template>

<script>
import { Dialog, Drawer } from 'element-ui'
import { getLangIdI18n } from "~/utils";

export default {
  name: 'RewardInfoDialog',
  components: {
    [Dialog.name]: Dialog,
    [Drawer.name]: Drawer
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    customStyle: {
      type: Object,
      default() {
        return {}
      }
    },
    title: String,
    isMobile: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    options() {
      const dialogOptions = {
        width: '480px',
        top: '20vh',
        customClass: 'reward-dialog-desktop'
      }
      const drawerOptions = {
        direction: 'btt',
        showClose: false,
        size: 'auto',
        customClass: 'reward-drawer-mobile'
      }
      return this.$store.getters.isMobile ? drawerOptions : dialogOptions
    }
  },
  methods: {
    getLangIdI18n,
    init() {
      this.visible = true
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style lang="less">
.reward-info-dialog {
  // Desktop Dialog Styles
  .el-dialog {
    border-radius: 12px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    
    &__header {
      padding: 20px 24px;
      border-bottom: 1px solid #f0f0f0;
      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #1a1a1a;
      }
      .el-dialog__headerbtn {
        display: none; // We use our custom close button
      }
    }
    
    &__body {
      padding: 0;
    }
  }

  // Mobile Drawer Styles
  .el-drawer {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    
    &__header {
      margin-bottom: 0;
      padding: 20px 24px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 18px;
      font-weight: 600;
      color: #1a1a1a;
    }
    
    &__body {
      padding: 0;
    }
  }

  .dialog-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    
    .title-text {
      font-size: 18px;
      font-weight: 600;
      color: #1a1a1a;
    }

    .close-btn {
      font-size: 20px;
      color: #999;
      cursor: pointer;
      transition: color 0.2s;
      flex-shrink: 0;

      &:hover {
        color: #333;
      }
    }

    .success-header {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
      justify-content: center;

      .icon-wrap {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: #52c41a;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 8px rgba(82, 196, 26, 0.3);
        
        i {
          font-size: 18px;
          font-weight: bold;
          color: #fff;
        }
      }

      .success-title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
      }
    }
  }

  .reward-info-content {
    position: relative;
    padding: 24px;
    background-color: #fff;

    .gift-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
      max-height: 400px;
      overflow-y: auto;
      
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #ddd;
        border-radius: 3px;
      }
    }

    .gift-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      background-color: #f8f9fa;
      border-radius: 8px;
      border: 1px solid transparent;
      transition: all 0.2s;

      &:hover {
        background-color: #fff;
        border-color: #e4e7ed;
        box-shadow: 0 4px 12px rgba(0,0,0,0.05);
      }

      .gift-info {
        display: flex;
        align-items: center;
        gap: 12px;

        .gift-img-wrap {
          width: 48px;
          height: 48px;
          border-radius: 8px;
          background-color: #fff;
          border: 1px solid #eee;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;

          &.has-level {
            border: none;
            border-radius: 0;
            background: var(--level-bg) no-repeat;
            background-color: transparent;
            background-size: 100% 100%;

            .gift-img {
              width: 80%;
              height: 80%;
              object-fit: contain;
            }
          }

          .gift-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .gift-name {
          font-size: 14px;
          font-weight: 500;
          color: #333;
        }
      }

      .gift-count {
        display: flex;
        align-items: center;
        color: #666;
        background: rgba(0,0,0,0.04);
        padding: 4px 8px;
        border-radius: 6px;

        .count-icon {
          font-size: 12px;
          margin-right: 2px;
        }

        .count-text {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
